<div class="col-12 d-flex flex-column flex-md-row main-container p-md-0 p-4">
    <div class="d-md-none d-flex justify-content-start align-items-start px-4  logo-position">
        <img src="../../../assets/logo/Odda-LightMode.svg" alt="Centered Image" class="ps-xl-5 ps-lg-0 img-fluid mt-2"
            style="width: 48% !important;" />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column align-items-center justify-content-between p-2 img-container"
        style="background-color: #D5E2F1;">
        <div class="d-md-flex d-none justify-content-start align-items-start p-4 w-100">
            <img src="../../../assets/logo/Odda-LightMode.svg" alt="Left Aligned Image"
                class="ps-xl-5 ps-lg-0 img-fluid " style="max-height: 100%;" />
        </div>
        <img src="../../../assets/gifs/sameday/sign-in.gif" alt="Centered Image" class="img-fluid mt-5 mt-md-2" />
    </div>

    @if(!emailNumber){
    <div
        class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-center align-items-center p-md-4 px-0 py-4">

        <div class="col-xxl-8 col-xl-10 col-lg-12 col-12 d-flex flex-column justify-content-center align-items-start p-md-4 p-0 gap-2"
            *ngIf="!phoneVerified">

            <div *ngIf="!submitted && !phoneVerified"
                class="d-flex flex-column justify-content-start align-items-start gap-md-3 gap-1  pb-5">
                <p routerLink="/login"
                    class="m-0 p-0 text-muted d-flex flex-row align-items-center justify-content-center back-txt"
                    style="text-align: left !important; font-size: clamp(12px,1.8vw,14px) !important;">
                    <span class="d-flex flex-row align-items-center justify-content-center me-2 back-btn">
                        <i class="bi bi-arrow-left-short fs-5 "></i> </span> Go Back to Sign In
                </p>
            </div>

            <p *ngIf="!submitted && loginViaEmail" class="  fw-medium p-1 m-1"
                style="font-size: clamp(16px,1.2vw,24px) !important;">
                Register Your Email
            </p>

            <p *ngIf="!submitted && !loginViaEmail" class="  fw-medium p-1 m-1"
                style="font-size: clamp(16px,1.2vw,24px) !important;">
                Register Your Phone Number
            </p>

            <div *ngIf="loginViaEmail && !submitted"
                class="mb-3 px-2 pt-3 pb-2 d-flex flex-column align-items-start justify-content-start"
                style="width: 100% !important;">
                <label for="email" class="form-label text-start">Enter Your Email</label>
                <input type="email" class="form-control email" [(ngModel)]="emailOrMobile" id="email"
                    placeholder="hello@odda.co.uk" (input)="emailChanged()" aria-describedby="emailHelp"
                    style="width: 100% !important; background-color: var(--input-color-alt) !important"
                    (keyup.enter)="onSubmit()" />

                <!-- <div class="form-check d-flex flex-row align-items-center ps-0 gap-2 justify-content-start my-2">
                    <input type="checkbox" class="form-check-input m-0 p-0" id="rememberMe" [(ngModel)]="rememberMe" />
                    <label class="form-check-label" for="rememberMe">Remember me</label>
                </div> -->

                <div *ngIf="emailError" class=" text-start mt-2">
                    <p [innerHTML]="emailError" style="color: var(--error-text) !important;" class="text-start "></p>
                </div>
            </div>

            <div *ngIf="!loginViaEmail && !submitted" class="px-2 pt-3 pb-2 d-flex flex-column col-12">
                <label for="email" class="form-label text-start">Enter Your Phone Number</label>
                <div class="d-flex flex-row">
                    <form #f="ngForm" class="col-12" [formGroup]="phoneForm">
                        <div class="wrapper">
                            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                [enableAutoCountrySelect]="true" [customPlaceholder]="numberPlaceholder"
                                [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name
                            ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedKingdom"
                                [maxLength]="15" [phoneValidation]="true" [separateDialCode]=true
                                [numberFormat]="PhoneNumberFormat.International" name="phone" formControlName="phone"
                                (keyup.enter)="onSubmit()" (keypress)="onKeyPress($event)">
                            </ngx-intl-tel-input>
                        </div>
                        <div *ngIf="emailError" class="text-start mt-1">
                            <p [innerHTML]="emailError" style="color: var(--error-text) !important;" class="text-start">
                            </p>
                        </div>
                    </form>
                </div>
            </div>

            <div *ngIf="!submitted" class="py-md-2 py-1 w-100">
                <button class="btn btn-primary mt-md-3 m-0 login-buttons" (click)="onSubmit()"
                    style="font-size: 16px !important;" type="submit">Get OTP</button>
            </div>

            <div *ngIf="submitted && !phoneVerified"
                class="col-12   d-flex flex-column align-items-center justify-content-center pe-lg-2 me-lg-3">

                <h2 class="text-start fs-4  fw-medium">
                    Enter OTP
                </h2>

                <p class="py-2 text-start w-100 text-center">
                    Please enter the <span class="fw-semibold">6 digit code</span>
                    sent to <br>
                    <span class="fw-semibold">{{emailOrMobile}}</span>
                </p>

                <ng-otp-input (onInputChange)="onOtpChange($event)" (keyup.enter)="onSubmit(true)"
                    [config]="{length:6, allowNumbersOnly:true}" style="color: black !important;"></ng-otp-input>

                <div class="py-3" style="width: 92%;">

                    <p class="text-danger fw-semibold" style="font-size: 14px; " *ngIf="invalidOTP"> Invalid OTP Entered
                    </p>
                    <p style="font-size: 13px;">
                        Wait for {{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }} <span
                            *ngIf="minutes === 0 && seconds === 0" style="cursor: pointer;">
                            <a class="text-primary fw-semibold" style="text-decoration: underline; font-size: 13px;"
                                (click)="resendCode()">Resend</a>
                            </span>
                    </p>
                </div>


                <div class="py-1" style="width: 92%;">
                    <button class="btn btn-primary mt-3 login-buttons" (click)="onSubmit(true)"
                        style="font-size: 16px !important;" type="submit">Verify</button>
                </div>


            </div>
            <div class="pt-5 d-flex flex-row justify-content-center align-items-center w-100">
                <p class="p-0 m-0 text-muted" style="font-size: 14px !important; ">
                    By signing up you agree to the terms and conditions
                </p>
            </div>
        </div>

        <div *ngIf="phoneVerified">
            <div class="py-3 d-flex flex-column justify-content-center align-items-start w-100">
                <h1 class="my-1 py-1 px-0 mx-0" *ngIf="this.successResponse!=null">Email Already Linked</h1>

                <p class="pb-2 mb-2 px-0 pt-0 mx-0 mt-0 text-success" *ngIf="this.successResponse!=null"
                    style="font-size: 14px !important; text-align: left !important;"> It seems your email is already
                    linked to an account. <br> Let us know which organisation you'd like to proceed with, and we'll get
                    you set up</p>

                <div class="col-auto pe-lg-4 pe-0 d-flex flex-column justify-content-start align-items-start scrollable"
                    *ngIf="this.successResponse!=null" style="max-height: 400px;overflow-y: auto;">
                    <div class="px-2 py-1 card border-0 shadow-sm mb-3 orgCard orgCardWidth"
                        style="cursor: pointer !important;" *ngFor="let org of orgDetails, let i = index"
                        (click)="loginUsingOrg(org)">
                        <div class="row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="icon-circle  d-flex justify-content-center align-items-center"
                                    style="width: 60px; height: 60px; border-radius: 50%; background-color: var(--dialog-bg);">
                                    <i class="bi bi-buildings fs-3 text-secondary"></i>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card-body">
                                    <h5 class="card-title mb-1"
                                        style="text-align: left !important; color: var(--txtDark); font-size: clamp(10px,1.8vw,14px) !important; font-weight: 500 !important;"
                                        *ngIf="org.orgName">{{org.orgName}}</h5>
                                    <h5 class="card-title mb-1"
                                        style="text-align: left !important; color: var(--txtDark); font-size: clamp(10px,1.8vw,14px) !important; font-weight: 500 !important;"
                                        *ngIf="!org.orgName && org.orgCode">{{org.orgCode}}</h5>

                                    <p class="card-text text-muted" style="text-align: left !important;">
                                        {{org.fullAddress}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="col-auto pe-lg-4 pe-0 d-flex flex-column justify-content-start align-items-start w-100">
                    <div class="separator pt-md-4 pt-2 pb-2 orgCardWidth" *ngIf="this.successResponse!=null">
                        <div class="line"></div>
                        <span>OR</span>
                        <div class="line"></div>
                    </div>

                    <div class="px-2 py-1 card border-0 shadow-sm mb-3 orgCard orgCardWidth"
                        style="cursor: pointer !important;">
                        <div class="row g-0 p-2 align-items-center">

                            <div class="col-auto">
                                <div class="icon-circle  d-flex justify-content-center align-items-center"
                                    style="width: 60px; height: 60px; border-radius: 50%; background-color: var(--dialog-bg);">
                                    <i class="bi bi-buildings fs-3 text-secondary"></i>
                                </div>
                            </div>

                            <div class="col">
                                <div class="card-body" (click)="newOrgRegister()">
                                    <p class="card-text text-muted"
                                        style="font-size: clamp(11px,1.4vw,16px) !important;text-align: left !important;">
                                        Register
                                        using
                                        new organisation</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @else{
    <div
        class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-center align-items-center p-md-4 px-0 py-4">
        <div
            class="col-xxl-8 col-xl-10 col-lg-12 col-12 d-flex flex-column justify-content-center align-items-start p-md-4 p-0 gap-3">
            <h1 class="py-3 fw-medium fs-3">Personal Information</h1>

            <div style="width: 100%;" class="d-flex flex-row align-items-center justify-content-between">
                <div style="width: 49%;" class="d-flex flex-column align-items-start justify-content-start">
                    <label for="name" class="form-label text-start">First Name</label>
                    <input type="text" class="form-control" [(ngModel)]="personalDetails.firstName" id="name"
                        placeholder="John" aria-describedby="emailHelp" (input)="clearError('firstName')"
                        style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                    <div *ngIf="errors['firstName']" class="text-danger">First Name is required</div>
                    <div *ngIf="errors['firstNameSingleWord']" class="text-danger">First Name must be one word only
                    </div>
                </div>

                <div style="width: 49%;" class="d-flex flex-column align-items-start justify-content-start">
                    <label for="name" class="form-label text-start">Last Name</label>
                    <input type="text" class="form-control" [(ngModel)]="personalDetails.lastName" id="name"
                        placeholder="Doe" aria-describedby="emailHelp" (input)="clearError('lastName')"
                        style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                    <div *ngIf="errors['lastName']" class="text-danger">Last Name is required</div>
                    <div *ngIf="errors['lastNameSingleWord']" class="text-danger">Last Name must be one word only</div>
                </div>
            </div>

            <div class="col-12 d-flex flex-column align-items-start justify-content-start">
                <label for="orgCategory" class="form-label text-start">User Type</label>
                <ng-select id="orgCategory" bindLabel="label" bindValue="value" [clearable]="false" [searchable]="false"
                    [multiple]="false" [items]="orgCategories" [(ngModel)]="personalDetails.orgCategory"
                    (search)="placeHolder()" (change)="placeHolder()" [placeholder]="orgCategoryPlaceholder">
                </ng-select>
                <div *ngIf="errors['orgCategoryError']" class="text-danger mt-1">User type is required</div>
            </div>

            <div *ngIf="personalDetails.orgCategory != 'NAT' && personalDetails.orgCategory != null"
                class="col-12 d-flex flex-column align-items-start justify-content-start">
                <label for="name" class="form-label text-start">Company Name</label>
                <input type="text" class="form-control" [(ngModel)]="personalDetails.company" id="name"
                    (change)="companyNameChanged()" placeholder="Enter your company name" aria-describedby="emailHelp"
                    style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                <div *ngIf="errors['companyNameError']" class="text-danger mt-1">Company name required</div>
            </div>

            <div *ngIf="personalDetails.orgCategory != 'NAT' && personalDetails.orgCategory != null"
                class="col-12 d-flex flex-column align-items-start justify-content-start">
                <label for="jobTitleList" class="form-label text-start">Job Title</label>
                <ng-select id="jobTitleList" [items]="jobTitleList" bindLabel="label" bindValue="value"
                    [(ngModel)]="personalDetails.jobtitle" [clearable]="false" [searchable]="true" [multiple]="false"
                    [placeholder]="JobTitlePlaceholder" (search)="placeHolder()" (change)="placeHolder()">
                </ng-select>
                <div *ngIf="errors['jobtitle']" class="text-danger mt-1">Job title is required</div>
            </div>

            <div class="col-12 d-flex flex-column align-items-start justify-content-start">
                <label for="name" class="form-label text-start">Address</label>
                <ng-select [disabled]="showAddressManually" class="select-editable" [items]="addresses"
                    style="text-align: left !important;" [multiple]="false" [placeholder]="addressPlaceholder"
                    [(ngModel)]="selectedAddress" (change)="onAddressChange($event)" [searchable]="true"
                    (search)="onAddressSearch($event)" [typeahead]="searchSubject">
                </ng-select>

                <div *ngIf="errors['address']" class="text-danger">Address is required</div>
            </div>

            @if(selectedAddress && !showAddressManually){
            <div class="w-100">
                <span class="addressNote d-flex align-items-center">
                    <img src="assets/icons/info.svg" alt="info" />
                    <span>
                        If any part of your address is missing, click
                        <span class="editNoteHighlight">Edit Address</span>
                        to enter it manually.
                    </span>
                </span>
            </div>
            }

            <div class="col-12 d-flex flex-row align-items-start justify-content-start">
                <div class="form-check form-switch me-2">
                    <input class="form-check-input" type="checkbox" id="toggleSwitch" [(ngModel)]="showAddressManually"
                        [disabled]="!selectedAddress" (change)="onManualAddressToggle()">
                    <label class="form-check-label" for="toggleSwitch">
                        <span class="toggle-icon" [class.checked]="showAddressManually"
                            [class.unchecked]="!showAddressManually"></span>
                    </label>
                </div>

                <label for="toggleSwitch" class="form-label text-start">edit address manually</label>
            </div>

            <!-- Address input field (only shown when checkbox is checked) -->
            <div *ngIf="showAddressManually"
                class="manualAddress d-flex flex-row align-items-start justify-content-between"
                (keyup.enter)="onSubmitInfo()" [ngClass]="{'fade-in': showAddressManually}" style="width: 100%;">

                <div style="width: 64%;" class="d-flex flex-column align-items-start justify-content-start gap-2">
                    <div class="col-12 d-flex flex-column align-items-start justify-content-start">
                        <input type="text" class="form-control" [(ngModel)]="manualAddress.additionalDetails"
                            id="additionalDetails" [placeholder]="doorNumberPlaceholder"
                            (input)="clearError('additionalDetails')"
                            style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                        <small *ngIf="errors['additionalDetailsRequired'] && manualAddress.additionalDetails ==''"
                            class="text-danger" style="text-align: start !important;">Adding a door number or
                            building name helps your driver reach you faster.</small>
                    </div>

                    <div class="col-12 d-flex flex-column align-items-start justify-content-start">
                        <input type="text" class="form-control" [(ngModel)]="manualAddress.address1" id="address1"
                            placeholder="Address Line 1" (input)="clearError('address1')"
                            style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                        <small *ngIf="errors['address1Required']" class="text-danger">Address Line 1 is required</small>
                        <small *ngIf="errors['address1Length']" class="text-danger">
                            Maximum 50 characters allowed
                        </small>
                    </div>

                    <div class="col-12 d-flex flex-column align-items-start justify-content-start">
                        <input type="text" class="form-control" [(ngModel)]="manualAddress.address2" id="address2"
                            placeholder="Address Line 2" (input)="clearError('address2')"
                            style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                        <small *ngIf="errors['address2Length']" class="text-danger">
                            Maximum 50 characters allowed
                        </small>
                    </div>

                    <div class="col-12 d-flex flex-column align-items-start justify-content-start">
                        <input type="text" class="form-control" [(ngModel)]="manualAddress.city" id="city"
                            placeholder="City" (input)="clearError('city')"
                            style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                        <small *ngIf="errors['city']" class="text-danger">City is required</small>

                    </div>
                </div>

                <div class="d-flex flex-column align-items-start justify-content-start" style="width: 34%;">
                    <input type="text" class="form-control text-uppercase" [(ngModel)]="manualAddress.postCode"
                        id="postCode" placeholder="Postal Code" pattern="^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$"
                        (keyup)="postalFormating()" (input)="clearError('postCode')"
                        style="width: 100% !important; background-color: var(--input-color-alt) !important" />
                    <small *ngIf="errors['postCode']" class="text-danger">Postal Code is required</small>
                    @if(!isPostalCodeValid && !errors['postCode']){
                    <small class="text-danger d-block mt-1">Enter a valid postal code</small>
                    }
                </div>
            </div>
        </div>
        <div class="py-md-2 py-1 w-100">
            <button class="btn btn-primary mt-md-3 m-0 login-buttons" [ngClass]="{'w-auto': isZapiet}"
                (click)="onSubmitInfo()" style="font-size: 16px !important;" type="submit">{{ isZapiet ? 'Proceed to
                Save Payment Method' : 'Register' }}</button>
        </div>
    </div>
    }

    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-body  d-flex flex-column justify-content-center align-items-center pt-2"
                    style="padding-top: 20px !important;">

                    <div class="d-flex justify-content-center align-items-center w-100">
                        <div class="d-flex justify-content-center align-items-center rounded-circle"
                            style="background-color: #59bf90; width: 35px; height: 35px; display: flex; border: 2px solid #C1EED9;">
                            <i class="bi bi-check fs-4 text-white"></i>
                        </div>
                    </div>


                    <h1 class="text-success fs-4 my-1 py-1">You're All Set.</h1>

                    <div
                        class="col-11 col-lg-8 col-md-10 d-flex  my-2 py-3 flex-column justify-content-center align-items-center">
                        <p style="font-size: clamp(12px, 1.4vw, 16px) !important;">Thank you for registering with
                            Odda. Once your account is set up, you'll receive a confirmation email.
                        </p>
                    </div>

                    <div class="d-flex my-1 py-1 justify-content-center align-items-center">
                        <button type="button" class="btn btn-outline-primary mt-3"
                            style="height: auto !important; width: 110px !important;" data-bs-dismiss="modal"
                            routerLink="/login">Close</button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Save Payment Details Modal (Zapiet flow) -->
    <div class="modal fade" id="savePaymentModal" tabindex="-1" aria-labelledby="savePaymentModalLabel"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered custom-zapiet-modal-dialog">
            <div class="modal-content custom-zapiet-modal-content p-4">
                <div class="d-flex justify-content-end w-100">
                    <button type="button" class="btn-close custom-modal-close" aria-label="Close"
                        (click)="closeSavePaymentModal()"></button>
                </div>

                <div class="modal-body p-0">
                    <!-- Brand Partner Badges: Separate icon wrappers -->
                    <div class="d-flex align-items-center justify-content-center mb-3">
                        <div class="d-flex align-items-center gap-2">
                            <div class="partner-icon-box">
                                <img src="assets/logo/Odda-LightMode.svg" alt="ODDA" class="partner-icon-img"
                                    onerror="this.onerror=null; this.src='assets/logo/odda.png';" />
                            </div>
                            <span class="partner-arrow">↔</span>
                            <div class="partner-icon-box">
                                <img src="assets/icons/stripe.svg" alt="Stripe" class="partner-stripe-img" />
                            </div>
                        </div>
                    </div>

                    <!-- Modal Title & Description (Left-aligned) -->
                    <div class="text-start w-100 mb-3">
                        <h3 class="zapiet-modal-title">Save payment details</h3>
                        <p class="zapiet-modal-subtitle">Add your card to continue. Your details are encrypted and
                            protected.</p>
                    </div>

                    <!-- Stripe Mount Wrapper -->
                    <div class="stripe-mount-container my-3">
                        <div *ngIf="isInitializingCardSetup"
                            class="d-flex flex-column align-items-center justify-content-center py-4">
                            <div class="spinner-border text-primary mb-2" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <small class="text-muted">Loading secure card form...</small>
                        </div>
                        <div id="payment-element"></div>
                    </div>

                    <!-- Security Badge -->
                    <div class="security-info-box d-flex align-items-start gap-2 p-3 my-3">
                        <div class="security-info-icon">
                            <i class="bi bi-shield-check text-success fs-5"></i>
                        </div>
                        <div class="security-info-text">
                            Your card details are encrypted, securely processed by Stripe, and never stored by ODDA.
                        </div>
                    </div>

                    <!-- Card Error Message -->
                    <div *ngIf="cardError"
                        class="alert alert-danger card-error-alert py-2 px-3 my-2 d-flex align-items-start gap-2">
                        <i class="bi bi-exclamation-circle-fill flex-shrink-0 mt-1"></i>
                        <span class="error-message-text">{{ cardError }}</span>
                    </div>

                    <!-- Save Card Button -->
                    <div class="mt-4">
                        <button type="button" class="btn btn-save-card-action w-100" (click)="saveCardDetails()"
                            [disabled]="isSavingCard || isInitializingCardSetup">
                            <span *ngIf="isSavingCard" class="spinner-border spinner-border-sm me-2" role="status"
                                aria-hidden="true"></span>
                            {{ isSavingCard ? 'Saving Card Details...' : 'Save Card Details' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- API Key Generated Modal (Zapiet flow) -->
    <div class="modal fade" id="apiKeyModal" tabindex="-1" aria-labelledby="apiKeyModalLabel" aria-hidden="true"
        data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered custom-zapiet-modal-dialog">
            <div class="modal-content custom-zapiet-modal-content p-4">
                <div class="d-flex justify-content-end w-100">
                    <button type="button" class="btn-close custom-modal-close" aria-label="Close"
                        (click)="closeApiKeyModal()"></button>
                </div>

                <div class="modal-body p-0">
                    <!-- Key Icon Badge -->
                    <div class="d-flex justify-content-center mb-3">
                        <div class="key-badge-circle d-flex align-items-center justify-content-center">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="7.5" cy="12" r="3.5" stroke="#10b981" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11 12H21M16 12V15.5M19 12V14" stroke="#10b981" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    <!-- Modal Title & Subtitle (Left aligned) -->
                    <div class="text-start w-100 mb-3">
                        <h3 class="zapiet-modal-title text-start">API Key Generated</h3>
                        <p class="zapiet-modal-subtitle text-start mb-0" *ngIf="!isShopify">Your ODDA &times; Stripe card details are saved
                            and ready for
                            future payments. We've also generated your secret API key below.</p>
                        <p class="zapiet-modal-subtitle text-start mb-0" *ngIf="isShopify">Your account has been registered successfully.
                            We've generated your secret API key below.</p>
                    </div>

                    <!-- Secret API Key Input Group -->
                    <div class="api-key-group my-3 text-start w-100">
                        <label class="form-label api-key-label text-start d-block">Secret API Key</label>
                        <div class="input-group api-key-input-wrapper">
                            <input type="text" class="form-control api-key-input" [value]="generatedApiKey" readonly />
                            <button class="btn btn-copy-key" type="button" (click)="copyApiKey()">
                                <i *ngIf="!isCopied" class="bi bi-clipboard me-1"></i>
                                <i *ngIf="isCopied" class="bi bi-check2 text-success me-1"></i>
                                {{ isCopied ? 'Copied' : 'Copy' }}
                            </button>
                        </div>
                    </div>

                    <!-- Secret Key Warning Box -->
                    <div class="api-key-warning-box d-flex align-items-center gap-2 p-3 my-3 text-start">
                        <div class="warning-icon-wrap flex-shrink-0">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#ef4444" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 8v4M12 16h.01" stroke="#ef4444" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="warning-text text-start">
                            Keep your API key private. Never share it publicly or expose it in client-side code.
                        </div>
                    </div>

                    <!-- Login Button -->
                    <div class="mt-4">
                        <button type="button" class="btn btn-login-action w-100" (click)="navigateToLogin()">
                            Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>